import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import SpriteComponent from '../../../Component/Render/Sprite';
import { delay } from '../../../Utility/Task/TaskQueue';

export class ScissorsWiggle extends AnimationClip {
    public *execute(gameObject: GameObject): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const scissorSprite = gameObject.getComponentsInChildren(
            SpriteComponent
        );

        const frames = ['scissors_1', 'scissors_2', 'scissors_3', 'scissors_4'];

        if (scissorSprite && scissorSprite.length > 0) {
            const fps = 24;
            const msPerFrame = 1500 / fps;
            while (true) {
                for (let i = 0; i < frames.length; i++) {
                    scissorSprite[0].texture = frames[i];
                    yield* delay(msPerFrame);
                }
            }
        }
    }
}
